import React from 'react';
import { ArticleSection } from './ArticleSection';
import { implementationSteps } from '../../data/articleLists';
export function ImplementationSection() {
  return <ArticleSection id="implementation" title="A 10-Step AI Workflow Automation Implementation Process" data-id="element-99" data-mp="3o6zijx1w269w">
      <p data-id="element-100" data-mp="3f84byjuxmu62">
        Whichever provider you choose, successful programmes follow a similar sequence. Skipping the early
        steps is the most common reason pilots stall.
      </p>
      <ol className="relative !mt-8 space-y-0" data-id="element-101" data-mp="fqwgq7xgjbth">
        {implementationSteps.map((step, index) => <li key={step.title} className="relative flex gap-5 pb-8 last:pb-0" data-id="element-102" data-mp="as35km5n7wwh" data-mpi={index}>
            {index < implementationSteps.length - 1 && <span aria-hidden="true" className="absolute left-5 top-11 h-[calc(100%-2.75rem)] w-px bg-line" data-id="element-103" data-mp="1u0xjmnhs3zp" />}
            <span className="relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full border border-aurora-cyan/40 bg-night-800 text-sm font-semibold text-aurora-cyan" data-id="element-104" data-mp="2rjbcwej0k678">
              {index + 1}
            </span>
            <div className="pt-1.5" data-id="element-105" data-mp="1ccrmrhlhkhm8">
              <h3 className="!mt-0 font-sans !text-lg font-semibold text-ink" data-id="element-106" data-mp="1heh0j503f9e0">{step.title}</h3>
              <p className="mt-1 !text-[0.975rem] !leading-7" data-id="element-107" data-mp="13ephgpupz2t5">{step.text}</p>
            </div>
          </li>)}
      </ol>
    </ArticleSection>;
}